import { useSyncExternalStoreWithSelector } from "use-sync-external-store/shim/with-selector";
import type { I18n } from "@lingui/core";
import { i18nStore, type I18nStoreState } from "src/stores/i18n/i18n.store";

export function useI18nStore<T>(
  selector: (state: I18nStoreState) => T,
  isEqual: (a: T, b: T) => boolean = Object.is
): T {
  return useSyncExternalStoreWithSelector(
    i18nStore.subscribe,
    i18nStore.getSnapshot,
    i18nStore.getServerSnapshot,
    selector,
    isEqual
  );
}

const selectI18n = (state: I18nStoreState) => state.i18n;

export function useI18n(): I18n {
  return useI18nStore(selectI18n);
}
